







































import {Component, Emit, Prop, Vue, Watch} from "vue-property-decorator";
import { TagContentsParam } from "@/params/TagContentsParam";
import VrTagImageDialog from "@/components/vr-tags/VrTagImageDialog.vue";
import VrTagMusicDialog from "@/components/vr-tags/VrTagMusicDialog.vue";
import VrTagMovieDialog from "@/components/vr-tags/VrTagMovieDialog.vue";
import VrTagProductDialog from "@/components/vr-tags/VrTagProductDialog.vue";
import VrTagProductMovieDialog from "@/components/vr-tags/VrTagProductMovieDialog.vue";


@Component({
  components: {
    VrTagProductMovieDialog,
    VrTagProductDialog,
    VrTagMovieDialog,
    VrTagMusicDialog,
    VrTagImageDialog
  }
})
export default class VrTagContents extends Vue {

  private shownDialog: any = {
    image: false,
    product: false,
    music: false,
    movie: false,
    productMovie: false
  };

  private dialogContents: any = {
    image: null,
    product: null,
    music: null,
    movie: null,
    productMovie: null
  };


  /* Property */
  @Prop() contentsData: TagContentsParam;
  @Prop() isShown: boolean;


  /* Watcher */
  @Watch('isShown')
  onChangeWatch (newValue: boolean, oldValue: boolean) {
    if (newValue) {
      if (this.contentsData.type === 'image') {
        this.shownDialog.image = true;
      }
      else if(this.contentsData.type === 'product') {
        this.shownDialog.product = true;
      }
      else if (this.contentsData.type === 'music') {
        this.shownDialog.music = true;
      }
      else if (this.contentsData.type === 'movie') {
        this.shownDialog.movie = true;
      }
      else if (this.contentsData.type === 'productMovie') {
        this.shownDialog.productMovie = true;
      }
    }
  }

  @Watch('contentsData')
  onChangeContents (newValue: TagContentsParam, oldValue: TagContentsParam) {
    if (newValue) {
      if (newValue.type === 'image') {
        this.dialogContents.image = newValue;
      }
      else if (newValue.type === 'product') {
        this.dialogContents.product = newValue;
      }
      else if (newValue.type === 'music') {
        this.dialogContents.music = newValue;
      }
      else if (newValue.type === 'movie') {
        this.dialogContents.movie = newValue;
      }
      else if (newValue.type === 'productMovie') {
        this.dialogContents.productMovie = newValue;
      }
    }
  }

  /* Emit Events */
  @Emit('close-contents')
  emitCloseContents (): void {}

  /* Event Handlers */
  private onCloseDialog (): void {
    if (this.contentsData.type === 'image') {
      this.shownDialog.image = false;
      // this.dialogContents.image = null;
    }
    else if (this.contentsData.type === 'product') {
      this.shownDialog.product = false;
    }
    else if (this.contentsData.type === 'music') {
      this.shownDialog.music = false;
    }
    else if (this.contentsData.type === 'movie') {
      this.shownDialog.movie = false;
    }
    else if (this.contentsData.type === 'productMovie') {
      this.shownDialog.productMovie = false;
    }

    setTimeout(() => {
      this.emitCloseContents();
    }, 300);
  }

}
